import { options_title, optionsFull_goToQuickOptions } from './CategoriesColumn.locstring.json';
import loc from 'owa-localize';
import { getStore, collectedOptions } from 'owa-options-store';
import { observer } from 'mobx-react-lite';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { OptionCategory } from 'owa-options-core';

import * as React from 'react';
import { selectCategory } from 'owa-options-orchestration';
import { hideFullOptions } from 'owa-options-core';
import FullOptionSearch from './FullOptionSearch';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface CategoryEntryProps {
    category: OptionCategory;
}

export const CategoryEntry = observer(function CategoryEntry(props: CategoryEntryProps) {
    let buttonStyles = {
        root: className(styles.category, {
            selectedCategory: getStore().currentCategoryKey === props.category.key,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };

    let iconProps = {
        iconName: props.category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };
    const onClick = React.useCallback(() => selectCategory(props.category), [props.category]);
    return (
        <ActionButton
            styles={buttonStyles}
            key={props.category.key}
            onClick={onClick}
            iconProps={iconProps}
            text={loc(props.category.titleStringKey) as string}
            role="tab"
        />
    );
});

export const CategoriesColumn = observer(function CategoriesColumn() {
    return (
        <div className={styles.categoriesColumn} role="tablist">
            <span className={styles.title} role="heading" aria-level={2}>
                {loc(options_title)}
            </span>
            <FullOptionSearch />
            <FocusZone direction={FocusZoneDirection.vertical}>
                {collectedOptions().map(category => (
                    <CategoryEntry category={category} key={category.key} />
                ))}
            </FocusZone>
            <ActionButton
                className={styles.viewQuickSettings}
                onClick={goToQuickOptions}
                text={loc(optionsFull_goToQuickOptions)}
            />
        </div>
    );
});

function goToQuickOptions() {
    hideFullOptions(true /* showQuickOptions */);
}
